import ky from 'ky';
import * as Sentry from '@sentry/react';

import { fetchAuthSession } from 'aws-amplify/auth';

import { runtimeConfig } from 'runtimeConfig';

const original = ky.create({
  prefix: runtimeConfig.backendUrl,
});

const extended = original.extend({
  hooks: {
    beforeRequest: [
      async ({ request }) => {
        try {
          const session = await fetchAuthSession();
          const token = session.tokens?.accessToken?.toString();
          if (token) {
            request.headers.set('Authorization', `Bearer ${token}`);
          }
        } catch (error) {
          if (error instanceof Error && error.name !== 'UserUnAuthenticatedException') {
            Sentry.captureException(error);
          }
        }
      },
    ],
  },
});

export default extended;
